import { render, staticRenderFns } from "./GoodBroadCaster.vue?vue&type=template&id=2c9dde46&scoped=true"
import script from "./GoodBroadCaster.vue?vue&type=script&lang=js"
export * from "./GoodBroadCaster.vue?vue&type=script&lang=js"
import style0 from "./GoodBroadCaster.vue?vue&type=style&index=0&id=2c9dde46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9dde46",
  null
  
)

export default component.exports